const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

export const formatCurrency = (amount: number): string => currencyFormatter.format(amount);

export const formatPercentage = (value: number): string => `${value.toFixed(1)}%`;

export const formatNumber = (value: number): string => value.toLocaleString();
